import { render, staticRenderFns } from "./ConfirmSignupDialog.vue?vue&type=template&id=28c35ff1&"
import script from "./ConfirmSignupDialog.vue?vue&type=script&lang=js&"
export * from "./ConfirmSignupDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports